export default {"src":"/_next/static/media/right-arrow.94e30f19.svg","height":17,"width":10};